import { Font } from "@react-pdf/renderer";

import latoRegular from "./fonts/Lato-Regular.ttf";
import latoItalic from "./fonts/Lato-Italic.ttf";
import latoBold from "./fonts/Lato-Bold.ttf";
import latoBlack from "./fonts/Lato-Black.ttf";

import TaskRelatory from "./TaskRelatory";
import React from "react";
import FlowRelatory from "./FlowRelatory";
import { ErrorPDF } from "../Erro";
export default function PDFComponent({ relatory }) {
  Font.register({
    family: "Lato",
    fonts: [
      { src: latoRegular },
      { src: latoItalic, fontStyle: "italic" },
      { src: latoBold, fontWeight: "bold" },
      { src: latoBlack, fontWeight: "heavy" },
    ],
  });

  return relatory ? (
    <React.Fragment>
      <FlowRelatory relatory={relatory} />
      <TaskRelatory relatory={relatory} />
    </React.Fragment>
  ) : (
    <ErrorPDF />
  );
}
